export default __webpack_public_path__ + "static/media/Logo.8a069b13.png";